export interface DownloadableFile {
  downloadUrl: string
  filename: string
}

/** Generate a file and begin its browser download, propagating failures so the
 * calling surface can restore its control and show contextual retry feedback. */
export async function generateAndDownloadFile(
  generate: () => Promise<DownloadableFile>,
  fallbackFilename: string,
): Promise<void> {
  const file = await generate()
  downloadFile(file, fallbackFilename)
}

/**
 * Start a browser download without navigating the app away from the current page.
 * The backend also returns Content-Disposition: attachment; the download attribute provides
 * a filename fallback for browsers that honor it for cross-origin URLs.
 */
export function downloadFile(file: DownloadableFile, fallbackFilename: string): void {
  if (!file.downloadUrl) {
    throw new Error('The generated PDF did not include a download URL')
  }

  const anchor = document.createElement('a')
  anchor.href = file.downloadUrl
  anchor.download = file.filename || fallbackFilename
  anchor.rel = 'noopener'
  anchor.style.display = 'none'

  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
}
